import React, { useState, useEffect, useMemo } from "react";
import { useLocation } from "react-router-dom";
import useCustomNavigate from "../../common_nextgen/common_components/Navigation/NextGenNavigation";
import Form from "../../common_nextgen/common_components/form/Form";
import { PRICE_SCHEDULE_MODES } from "../../common_nextgen/utils/Constants";
import {
  isAddMode,
  isEditMode,
  isReadOnlyMode,
} from "../../common_nextgen/utils/UtilFunctions";
import {
  ROUTE_PATHS,
  LEGACY_SCREEN_VIEW,
  LOCAL_SCREEN_VIEW,
  NO_CHANGE_OF_INFO
} from "../../common_nextgen/utils/Constants";
import { useAxios } from "../../common_nextgen/axios/AxiosHelper";
import { useToast } from "../../common_nextgen/hooks/ToastContext";
import FunctionKeys from "../../common_nextgen/common_components/FunctionKeys/FunctionKeys";
import { formFields } from "./PatientPayTableDetailConfig";
import MinMaxList from "./MinMaxList";
import { useModal } from "../../common_nextgen/hooks/ModalContext";
import { LegacyResolvers } from "../../common_nextgen/utils/UtilFunctions";
import "./css/PatientPayDetailForm.css";
import useLookupNavigation from "../../common_nextgen/common_components/common-hooks/useLookupNavigation";

const screenInfo = {
  ADD: ["Add Patient Pay Table Detail", "RCPS4033"],
  CHANGE: ["Patient Pay Table Detail", "RCPS4005"],
  VIEW: ["Patient Pay Table Detail", "RCPS4005"],
};

const PatientPayTableDetailForm = ({
  mode,
  selectMode,
  lookupType: initialLookupType,
  hideModal,
  intialSchedule,
}) => {
  const { axios_helper_no_header } = useAxios();
  const location = useLocation();

  const { state: stateVal } = location;
  let [currentState = {}] = [...stateVal].reverse();
  const previousState = [...stateVal];
  previousState.splice(stateVal.length - 1, 1);
  //console.log("current state in form", currentState, previousState);
  let {
    /** @todo ensure if  `selectedSchedules` works correctly */
    selectedSchedules = [],
    selectedPatients = [],
    currentIndex: initialIndex = 0,
    paramsData,
    showMinMaxModel = false,
    lookupMode: initialLookupMode = false,
    lookupScreen,
    lookupParams,
    navigateData,
    formData: baseFormData = {},
    previousScreen,
    currentMode: baseMode = mode,
  } = currentState;

  //const previousScreen = ROUTE_PATHS.PATIENT_PAY_TABLE;

  const navigateToPage = useCustomNavigate();
  const [selectedOption, setSelectedOption] = useState("no");
  const [currentIndex, setCurrentIndex] = useState(initialIndex);
  const [currentMode, setCurrentMode] = useState(baseMode);
  const [initialFormData, setInitialFormData] = useState(baseFormData);
  const [dataForSubmission, setDataForSubmission] = useState({});
  const [constraintErrors, setConstraintErrors] = useState([]);
  const [isConfirmationModalOpen, setIsConfirmationModalOpen] = useState(false);
  const [submittedData, setSubmittedData] = useState({});
  const toast = useToast();
  const { PATIENT_PAY_TABLE_NOTE } = ROUTE_PATHS;
  const { showModal } = useModal();
  const [selectedPatient, setSelectedPatient] = useState(intialSchedule);
  /*  const [lookupData, setLookupData] = useState({});
  const [lookupMode, setLookupMode] = useState(initialLookupMode);
  console.log("initialFormData", initialFormData);

  const handleReceiveData = (data) => {
    //setInitialFormData({ ...initialFormData, ...data });
    if (data && Object.keys(data).length) {
      setLookupData(data);
    }
  };
  const resetLookupMode = () => {
    setLookupMode(false);
  };
  const fetchLookupData = (lookupScreen, params, formData) => {
    showModal(
      lookupScreen,
      { params },
      handleReceiveData,
      formData,
      false,
      handleNavigate,
      resetLookupMode
    );
    showModal(
      lookupScreen,
      { params },
      handleReceiveData,
      formData,
      false,
      handleNavigate,
      resetLookupMode
    );
  };

  const viewLookupDetails = (lookupScreen, params, formData) => {
    const { viewType, fieldMapping } = params;
    const { default: screenNumber } = lookupScreen;
    const { default: viewParams } = fieldMapping;

    if (viewType === "legacy") {
      const paramData = viewParams.reduce((acc, item) => {
        const resolver = item["resolver"]
          ? LegacyResolvers[item["resolver"]]
          : null;
        acc[item["legacy"]] = resolver
          ? resolver(formData[item["source"]])
          : formData[item["source"]];
        return acc;
      }, {});
      const message = {
        message: "navigate-to-presto",
        programCode: LEGACY_SCREEN_VIEW[screenNumber],
        parameters: params?.extraParam
          ? {
              ...paramData,
              cssStatePricing: formData?.statePricing
                ? formData?.statePricing
                : "N",
            }
          : paramData,
      };
      console.log("message", message);
      window.top?.postMessage(message, "*");
    } else {
      //showModal(lookupScreen, { params }, null, formData, true);
      // const { default: screenNumber } = lookupScreen;
      const paramData = viewParams.reduce((acc, item) => {
        const resolver = item["resolver"]
          ? LegacyResolvers[item["resolver"]]
          : null;
        acc[item["target"]] = resolver
          ? resolver(formData[item["source"]])
          : formData[item["source"]];
        return acc;
      }, {});
      //console.log("param data", paramData);
      const navigationPath = ROUTE_PATHS[LOCAL_SCREEN_VIEW[screenNumber]];
      navigateToPage(navigationPath, [
        ...previousState,
        { ...currentState, currentIndex, formData: formData },
        {
          selectedSchedules: [paramData],
          currentIndex: 0,
          paramsData: { ...paramData, cscStepNbr: null },
          previousScreen: location.pathname,
        },
      ]);
    }
  };

  const handleNavigate = (data, screenNumber, params, formData) => {
    // console.log(data);
    if (data?.navType === "local") {
      const schedulesDataKey = data?.schedulesDataKey ?? "selectedPatients";
      const additionalData = data?.additionalData ?? {};
      navigateToPage(data.target, [
        ...previousState,
        {
          ...currentState,
          currentIndex,
          lookupMode: true,
          lookupScreen: screenNumber,
          lookupParams: params,
          navigateData: data.data,
          formData: formData,
        },
        {
          [schedulesDataKey]: [data.data],
          previousScreen: location.pathname,
          // paramsData: data.data,
          currentIndex: 0,
          ...additionalData,
        },
      ]);
    }
  };

  useEffect(() => {
    if (lookupMode && initialFormData && Object.keys(initialFormData).length) {
      //console.log("lookup auto init", initialFormData, navigateData);
      //const lookupParamsData =
      console.log("navigate data", lookupParams, navigateData);
      //navigateData;
      const params = lookupParams.fieldMapping.default;
      const paramData = params?.reduce((acc, key) => {
        if (navigateData.hasOwnProperty(key["target"])) {
          acc[key["source"]] = navigateData[key["target"]];
        }
        return acc;
      }, {});
      showModal(
        lookupScreen,
        { params: lookupParams },
        handleReceiveData,
        { ...initialFormData, ...paramData },
        null,
        handleNavigate,
        resetLookupMode
      );
    }
  }, [initialFormData, lookupMode, lookupParams, lookupScreen]);
  */
  const {
    lookupData,
    fetchLookupData,
    viewLookupDetails,
    lookupMode,
    setLookupMode,
  } = useLookupNavigation({
    initialLookupMode,
    lookupScreen,
    lookupParams,
    initialIndex: currentIndex,
    currentState,
    previousState,
    navigateData,
    currentMode,
    initialFormData,
  });
  const handleBack = () => {
    if (selectMode) {
      hideModal();
    } else if (currentIndex < selectedPatients.length - 1) {
      setCurrentIndex(currentIndex + 1);
      setCurrentMode(mode);
    } else {
      const lastScheduleName =
        selectedPatients[currentIndex]?.ps4PtPaySchTableName || "";
      const updatedParamsData = {
        ...currentState.paramsData,
        ps4PtPaySchTableName: lastScheduleName,
      };
      const lastRecord = previousState.pop();
      console.log("last record", lastRecord);
      navigateToPage(previousScreen, [
        ...previousState,
        {
          ...lastRecord,
          showMinMaxModel: false,
          paramsData: updatedParamsData,
          currentIndex,
        },
      ]);
    }
  };

  const openConfirmationModal = () => setIsConfirmationModalOpen(true);
  const closeConfirmationModal = () => setIsConfirmationModalOpen(false);
  const [dialogVisible, setDialogVisible] = useState(false);

  const getPageTitle = () => {
    const [screenTitle, screenNumber] = isAddMode(mode)
      ? screenInfo.ADD
      : screenInfo.CHANGE;
    return (
      <>
        <span className="title">{screenTitle}</span>
        <span>-</span>
        <span className="screen-number">{screenNumber}</span>
      </>
    );
  };

  const submitForm = async (dataForSubmission) => {
    let url = "";
    let verb = "";
    let screenNumber = "";
    let infoChanged = true;

    if (isAddMode(currentMode)) {
      url = "api/ps4PatientPaySchTable";
      verb = "POST";
      screenNumber = screenInfo.ADD[1];
    } else {
      url = "api/ps4PatientPaySchTable";
      verb = "PUT";
      screenNumber = screenInfo.CHANGE[1];

      if (
        JSON.stringify(dataForSubmission) === JSON.stringify(initialFormData)
      ) {
        infoChanged = false;
      }
    }

    const data = { ...dataForSubmission, screenNumber, infoChanged };

    try {
      const { responseStatus, responseData } = await axios_helper_no_header(
        verb,
        url,
        data,
        null
      );
      if (responseStatus.message === NO_CHANGE_OF_INFO) {
                                          toast.current.show({
                                            severity: "info",
                                            summary: "",
                                            detail: responseStatus.message,
                                            life: 3000,
                                          });
                                        } else {
                                          toast.current.show({
                                            severity: "success",
                                            summary: "",
                                            detail: responseStatus.message,
                                            life: 3000,
                                          }); 
      setInitialFormData(responseData);
      if (isAddMode(currentMode)) {
        setCurrentMode(PRICE_SCHEDULE_MODES.EDIT);
        setSubmittedData(dataForSubmission);
        currentState = {
          ...currentState,
          selectedPatients: [{ ...responseData }],
          currentIndex: 0,
        };
        navigateToPage(ROUTE_PATHS.EDIT_PATIENT_PAY_TABLE_DETAIL, [
          ...previousState,
          currentState,
        ]);
      }
    } }catch (error) {
      const { responseStatus: { displayErrorFields = null, message } = {} } =
        error.data;
      if (displayErrorFields === null) {
        toast.current.show({
          severity: "error",
          summary: "",
          detail: message,
          life: 3000,
        });
      } else {
        setConstraintErrors(displayErrorFields);
      }
    }
  };

  const handleMinMax = async () => {
    try {
      // Ensure selectedPatients and currentIndex are valid
      var scheduleName;
      const selectedPatient = selectedPatients?.[currentIndex];
      if (selectedPatient) {
        scheduleName = selectedPatients?.[currentIndex]?.ps4PtPaySchTableName;
      } else {
        scheduleName = submittedData?.ps4PtPaySchTableName;
      }

      const url = `api/appaddlpatientpay/${encodeURIComponent(scheduleName)}`;

      // Await the API call and destructure the response
      var response;
      try {
        response = await axios_helper_no_header("GET", url);
      } catch (e) {
        console.error("Error navigating to the edit page:", e);
      }

      // Check response status and proceed if successful
      if (
        response &&
        response?.responseStatus?.statusCode === "SUCCESS" &&
        response?.responseData?.ps4PtPaySchTableName
      ) {
        navigateToPage(ROUTE_PATHS.EDIT_PATIENTPAY_TABLE_ADDIITIONAL_SCHEDULE, [
          ...previousState, // Preserve previous state
          { ...currentState, currentIndex }, // Update current state
          {
            selectedSchedules: [selectedPatient],
            previousScreen: location.pathname,
            paramsData,
          },
        ]);
      } else {
        navigateToPage(ROUTE_PATHS.ADD_PATIENTPAY_TABLE_ADDIITIONAL_SCHEDULE, [
          ...previousState, // Preserve previous state
          { ...currentState, currentIndex }, // Update current state
          {
            selectedSchedules: [selectedPatient],
            previousScreen: location.pathname,
            submittedData: submittedData,
            paramsData,
          },
        ]);
      }
    } catch (error) {
      console.error("Error navigating to the page:", error);
      // Handle the error, maybe show a toast notification or alert
    }
  };

  const handleMinMaxForDisplay = async () => {
    // Ensure selectedPatients and currentIndex are valid
    let scheduleName;
    const selectedPatient = selectedPatients?.[currentIndex];
    if (selectedPatient) {
      scheduleName = selectedPatients?.[currentIndex]?.ps4PtPaySchTableName;
    } else {
      scheduleName = submittedData?.ps4PtPaySchTableName;
    }
    axios_helper_no_header(
      "GET",
      `api/appaddlpatientpay/${encodeURIComponent(scheduleName)}`,
      null,
      null
    )
      .then((response) => {
        navigateToPage(
          ROUTE_PATHS.DISPLAY_PATIENTPAY_TABLE_ADDIITIONAL_SCHEDULE,
          [
            ...previousState, // Preserve previous state
            { ...currentState, currentIndex }, // Update current state
            {
              selectedSchedules: [selectedPatient],
              previousScreen: location.pathname,
              paramsData,
            },
          ]
        );
      })
      .catch((error) => {
        console.error("There was an error validating the data!", error);
        const { responseStatus: { displayErrorFields = null, message } = {} } =
          error.data;
        toast.current.show({
          severity: "error",
          summary: "",
          detail: message,
          life: 3000,
        });
        closeConfirmationModal();
      });
  };

  const [keyFunc, keyName] = useMemo(() => {
    const keyFunc = {};
    const keyName = {};
    if (selectMode) {
      keyFunc.F12 = handleBack;
      keyName.F12 = "Back";
    } else if (isAddMode(currentMode)) {
      keyFunc.F12 = handleBack;
      keyName.F12 = "Back";
    } else if (isEditMode(currentMode)) {
      keyFunc.F12 = handleBack;
      keyName.F12 = "Back";
      keyFunc.chmod = () => setCurrentMode(PRICE_SCHEDULE_MODES.READ_ONLY);
      keyName.chmod = "View";

      // keyFunc.F7 = handleBack;
      keyFunc.F7 = () => {
        setDialogVisible(true);
      };
      keyName.F7 = "Min/Max";
      keyFunc.F9 = handleMinMax;
      keyName.F9 = "Additional";
      keyFunc.F14 = () =>
        navigateToPage(PATIENT_PAY_TABLE_NOTE, [
          ...previousState,
          { ...currentState, currentIndex },
          {
            selectedPatients: [selectedPatients[currentIndex]],
            previousScreen: location.pathname,
          },
        ]);
      keyName.F14 = "Note";
    } else if (isReadOnlyMode(currentMode)) {
      keyFunc.F12 = handleBack;
      keyName.F12 = "Back";

      // keyFunc.F7 = handleBack;
      keyFunc.F7 = () => {
        setDialogVisible(true);
      };
      keyFunc.chmod = () => setCurrentMode(PRICE_SCHEDULE_MODES.EDIT);
      keyName.chmod = "Edit";
      keyName.F7 = "Min/Max";
      keyFunc.F9 = handleMinMaxForDisplay;
      keyName.F9 = "Additional";
      keyFunc.F14 = () =>
        navigateToPage(PATIENT_PAY_TABLE_NOTE, [
          ...previousState,
          { ...currentState, currentIndex },
          {
            selectedPatients: [selectedPatients[currentIndex]],
            previousScreen: location.pathname,
          },
        ]);

      keyName.F14 = "Note";

      keyFunc.chmod = () => setCurrentMode(PRICE_SCHEDULE_MODES.EDIT);
      keyName.chmod = "Edit";
    }

    return [keyFunc, keyName];
  }, [currentMode, currentIndex, selectMode, selectedSchedules]);

  useEffect(() => {
    const fetchInitialData = async () => {
      const url = isAddMode(currentMode)
        ? `api/ps4PatientPaySchTable/initial-form-data/RCPS4033`
        : `api/ps4PatientPaySchTable/${encodeURIComponent(
            selectMode
              ? selectedPatient?.ppcPatientPayTable
              : currentState?.selectedPatients?.[currentIndex]
                  ?.ps4PtPaySchTableName
          )}`;

      try {
        const { responseData } = await axios_helper_no_header("GET", url);
        setInitialFormData(responseData);
      } catch (e) {
        console.log(e);
      }
    };
    if (!Object.keys(baseFormData).length) {
      fetchInitialData();
    }
  }, [mode, currentIndex, selectMode, selectedPatient]);

  useEffect(() => {
    if (showMinMaxModel) {
      setDialogVisible(true);
    }
  }, [showMinMaxModel]);

  useEffect(() => {
    setCurrentIndex(initialIndex);
  }, [initialIndex]);
  useEffect(() => {
    setLookupMode(initialLookupMode);
  }, [initialLookupMode]);
  /*useEffect(() => {
    setInitialFormData(baseFormData);
  }, [baseFormData]);*/

  return (
    <div className="grid container">
      <MinMaxList
        visible={dialogVisible}
        onHide={() => setDialogVisible(false)}
        selectedRows={[selectedPatients[currentIndex]]}
        rowData={[selectedPatients[currentIndex]]}
        prevScreen={location.pathname}
        previousState={previousState}
        currentState={currentState}
        currentParentIndex={currentIndex}
      />
      <div className="col col-12">
        <FunctionKeys keyFunc={keyFunc} keyName={keyName} />
      </div>
      <div className="col col-12">
        <h1>{getPageTitle()}</h1>
      </div>
      <div className="col col-12">
        <Form
          formData={initialFormData}
          formFields={formFields}
          mode={currentMode}
          submitFormData={submitForm}
          constraintErrors={constraintErrors}
          fetchLookupData={fetchLookupData}
          lookupData={lookupData}
          viewLookupDetails={viewLookupDetails}
        />
      </div>
    </div>
  );
};

export default PatientPayTableDetailForm;
